import { Badge } from "@/atoms"

import type { StatusProps } from "."

export const Status = (props: StatusProps) => {
  const { status, t, value } = props

  return (
    <Badge
      color={`var(--${status}-app-bg-color-ink-tag)`}
      text={
        <span className="sm-text-ks">
          {value} <span>{t(`triage.drawer.impact.status.${status}`)}</span>
        </span>
      }
    />
  )
}
